import ItemPayment from './ItemPayment.jsx';

export {
  ItemPayment
}


// WEBPACK FOOTER //
// ./components/my-business/sub-view/payment/index.js